import FileSaver from "file-saver"

type fileDataType = Blob | File | string;


export default (fileData: fileDataType, fileName: string) => {
  FileSaver.saveAs(fileData, fileName, { autoBom: true })
}
